import React, {useContext} from 'react';
import {DatasContext} from '../datas/DatasContext';

export default function Footer() {

    const {identity} = useContext(DatasContext)

    return (
        <footer role="contentinfo" className="text-[10px] leading-4 mb-0">
            <p className="text-[10px] leading-4 mb-0">
                Tous droits réservés, <a href={identity.site.title} title={identity.site.title}>{identity.site.title}</a><br/>© {new Date().getFullYear()} 
            </p>
        </footer>
    )
}